import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BmiLabelComponent} from './bmi-label.component';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
    ],
    declarations: [
        BmiLabelComponent
    ],
    exports: [
        BmiLabelComponent
    ]
})
export class BmiLabelModule {}
